// Schema.org constants and shared data
export const SCHEMA_CONTEXT = "https://schema.org";

// Company information
export const COMPANY_INFO = {
  name: "Pickcel",
  alternateName: "Digital Signage Software Solution for Every Business",
  description: "Run Stunning Digital Signage Displays with Pickcel's On-Premise & Cloud-Based Digital Signage Software Solutions. Quick Setup & User-Friendly Interface.",
  logo: "https://www.pickcel.com/assets/img/pickcel-logo.svg",
  url: "https://www.pickcel.com",
  email: "contact@pickcel.com",
  telephone: "+1-917-795-8876, +91-974-099-7922",
  addresses: [
    {
      "@type": "PostalAddress",
      addressCountry: "US",
      addressLocality: "New York",
      addressRegion: "NY",
      postalCode: "10013",
      streetAddress: "SoHo - Hudson Square, 101 Avenue of the Americas, 8th and 9th Floors"
    },
    {
      "@type": "PostalAddress",
      addressCountry: "IN",
      addressLocality: "Bangalore",
      addressRegion: "KA",
      postalCode: "560102",
      streetAddress: "#918, 3rd Floor, 5th Main Road, Sector 7, HSR Layout"
    }
  ],
  sameAs: [
    "https://x.com/PickcelSignage",
    "https://www.facebook.com/PickcelDigitalSignage",
    "https://www.linkedin.com/company/pickcel/",
    "https://www.youtube.com/channel/UCymlUh_ErgjloeyCnzH711g",
    "https://www.instagram.com/pickceldigitalsignage/"
  ]
} as const;

// Software application details
export const SOFTWARE_APP_INFO = {
  name: "Pickcel",
  operatingSystem: "Web, Android, iOS, Windows, Linux, ChromeOS, LG webOS, Samsung Tizen",
  applicationCategory: "BusinessApplication",
  offers: {
    "@type": "Offer",
    price: 13.5,
    priceCurrency: "USD"
  }
} as const;

// Common keywords
export const COMMON_KEYWORDS = [
  "Digital Signage",
  "Digital Signage India",
  "Cloud Digital Signage",
  "Cloud Digital Signage India",
  "Digital Signage Software India",
  "Digital Signage Solutions India",
  "Digital Signage Software Solutions India",
  "Cloud Digital Signage Software Solutions India"
] as const;
